'use client';
import React from 'react';
import Link from 'next/link';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { useLanguage } from '@/lib/LanguageContext';
import { getTranslations } from '@/lib/i18n';

// metadata removed - client component

const results = [
  { value: '0', labelEs: 'Incidentes críticos post-implementación', labelFr: 'Incidents critiques post-implémentation' },
  { value: '95%', labelEs: 'Reducción de vulnerabilidades detectadas', labelFr: 'Réduction des vulnérabilités détectées' },
  { value: '+200', labelEs: 'Usuarios capacitados en ciberseguridad', labelFr: 'Utilisateurs formés en cybersécurité' },
  { value: '24/7', labelEs: 'Monitoreo de amenazas activo', labelFr: 'Surveillance des menaces active' },
];


const sectors = [
  { icon: 'fas fa-university', labelEs: 'Finanzas', labelFr: 'Finance' },
  { icon: 'fas fa-hospital', labelEs: 'Salud', labelFr: 'Santé' },
  { icon: 'fas fa-building', labelEs: 'Gobierno', labelFr: 'Gouvernement' },
  { icon: 'fas fa-industry', labelEs: 'Industria', labelFr: 'Industrie' },
  { icon: 'fas fa-store', labelEs: 'Retail', labelFr: 'Commerce' },
];


const capabilities = [
  {
    icon: 'fas fa-search',
    titleEs: 'Análisis de Vulnerabilidades',
    titleFr: 'Analyse des Vulnérabilités',
    descriptionEs: 'Evaluaciones exhaustivas de seguridad con herramientas especializadas para identificar y priorizar vulnerabilidades en sistemas, redes y aplicaciones.',
    descriptionFr: 'Évaluations exhaustives de sécurité avec des outils spécialisés pour identifier et prioriser les vulnérabilités dans les systèmes, réseaux et applications.',
  },
  {
    icon: 'fas fa-shield-alt',
    titleEs: 'Firewall de Nueva Generación',
    titleFr: 'Pare-feu de Nouvelle Génération',
    descriptionEs: 'Implementación y configuración de NGFW con inspección profunda de paquetes, filtrado de aplicaciones y prevención de intrusiones en tiempo real.',
    descriptionFr: 'Déploiement et configuration de NGFW avec inspection approfondie des paquets, filtrage des applications et prévention des intrusions en temps réel.',
  },
  {
    icon: 'fas fa-user-secret',
    titleEs: 'Ethical Hacking',
    titleFr: 'Hacking Éthique',
    descriptionEs: 'Pruebas de penetración controladas que simulan ataques reales para descubrir debilidades antes de que actores maliciosos puedan explotarlas.',
    descriptionFr: 'Tests de pénétration contrôlés qui simulent des attaques réelles pour découvrir les faiblesses avant que des acteurs malveillants puissent les exploiter.',
  },
  {
    icon: 'fas fa-eye',
    titleEs: 'SOC y Monitoreo',
    titleFr: 'SOC et Surveillance',
    descriptionEs: 'Centro de operaciones de seguridad con correlación de eventos SIEM, detección de anomalías y respuesta a incidentes en tiempo real.',
    descriptionFr: 'Centre d\'opérations de sécurité avec corrélation d\'événements SIEM, détection d\'anomalies et réponse aux incidents en temps réel.',
  },
  {
    icon: 'fas fa-lock',
    titleEs: 'Gestión de Identidades',
    titleFr: 'Gestion des Identités',
    descriptionEs: 'Soluciones IAM con autenticación multifactor, privilegios mínimos y gestión centralizada de accesos para reducir la superficie de ataque.',
    descriptionFr: 'Solutions IAM avec authentification multifacteur, privilèges minimaux et gestion centralisée des accès pour réduire la surface d\'attaque.',
  },
  {
    icon: 'fas fa-graduation-cap',
    titleEs: 'Concientización y Capacitación',
    titleFr: 'Sensibilisation et Formation',
    descriptionEs: 'Programas de formación en ciberseguridad para equipos técnicos y usuarios finales, reduciendo el riesgo del factor humano en incidentes.',
    descriptionFr: 'Programmes de formation en cybersécurité pour les équipes techniques et les utilisateurs finaux, réduisant le risque du facteur humain dans les incidents.',
  },
];


export default function PortfolioCiberseguridadPage() {
  const { language } = useLanguage();
  const t = getTranslations(language);
  const p = t?.portfolio;
  const isFr = language === 'fr';

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: "'Nunito Sans', 'Raleway', arial, sans-serif" }}>
      <Navbar />
      {/* Hero */}
      <section
        className="relative overflow-hidden"
        style={{ paddingTop: '160px', paddingBottom: '80px', backgroundColor: '#0a0a0a' }}>
        
        <div className="absolute top-20 right-10 opacity-20 hidden lg:block">
          <img src="https://innobox.cl/wp-content/uploads/2021/07/Dots-4.svg" alt="" className="w-40 h-40" />
        </div>
        <div className="absolute bottom-0 left-0 opacity-10 hidden lg:block">
          <img src="https://innobox.cl/wp-content/uploads/2021/07/Abstract-Circle.svg" alt="" className="w-64 h-64" />
        </div>

        <div className="max-w-[1200px] mx-auto px-[35px] relative z-10">
          <nav className="mb-8 flex items-center gap-2 text-sm" style={{ color: '#888' }}>
            <Link href="/" className="hover:text-[#1AEF0F] transition-colors">{p?.breadcrumbHome}</Link>
            <span>/</span>
            <Link href="/#portfolio" className="hover:text-[#1AEF0F] transition-colors">{p?.breadcrumbPortfolio}</Link>
            <span>/</span>
            <span style={{ color: '#1AEF0F' }}>{isFr ? 'Cybersécurité' : 'Ciberseguridad'}</span>
          </nav>

          <div className="flex flex-col lg:flex-row items-start gap-12">
            <div className="flex-1">
              <div
                className="inline-flex items-center gap-2 mb-6 px-4 py-2"
                style={{ border: '1px solid #1AEF0F', color: '#1AEF0F', fontSize: '13px', letterSpacing: '2px' }}>
                
                <i className="fab fa-cloudflare" />
                <span>{isFr ? 'CAS D\'ÉTUDE' : 'CASO DE ESTUDIO'}</span>
              </div>
              <h1
                className="text-white font-bold mb-6"
                style={{
                  fontSize: 'clamp(32px, 4vw, 56px)',
                  fontFamily: "'Titillium Web', sans-serif",
                  lineHeight: '1.15'
                }}>
                
                {isFr ? 'Cyber' : 'Ciber'}<span style={{ color: '#1AEF0F' }}>{isFr ? 'sécurité' : 'seguridad'}</span>
              </h1>
              <p className="mb-8" style={{ fontSize: '18px', color: '#aaa', lineHeight: '1.7', maxWidth: '560px' }}>
                {isFr ? 'Implémentation d\'une stratégie de cybersécurité complète pour une institution financière, atteignant zéro incident critique et une réduction de 95% des vulnérabilités.' : 'Implementación de una estrategia integral de ciberseguridad para una institución financiera, logrando cero incidentes críticos y reducción del 95% de vulnerabilidades.'}
              </p>
              <div className="flex flex-wrap gap-4">
                <a
                  href="https://calendar.app.google/qrMMuz1WHJJ4eoab8"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group relative inline-flex items-center overflow-hidden"
                  style={{
                    border: '1px solid #1AEF0F',
                    padding: '14px 32px',
                    fontSize: '15px',
                    fontWeight: 'bold',
                    color: '#1AEF0F',
                    backgroundColor: 'transparent',
                    transition: 'all 300ms ease-out'
                  }}>
                  
                  <span className="relative z-10 transition-colors duration-300 group-hover:text-black">
                    {isFr ? 'Projet Similaire' : 'Proyecto Similar'}
                  </span>
                  <span
                    className="absolute inset-0 transform translate-x-full group-hover:translate-x-0 transition-transform duration-300"
                    style={{ backgroundColor: '#1AEF0F', zIndex: 0 }} />
                  
                </a>
                <Link
                  href="/#portfolio"
                  className="inline-flex items-center gap-2 text-white hover:text-[#1AEF0F] transition-colors"
                  style={{ fontSize: '15px', padding: '14px 0' }}>
                  
                  <i className="fas fa-arrow-left text-sm" />
                  {isFr ? 'Voir tout le portfolio' : 'Ver todo el portfolio'}
                </Link>
              </div>
            </div>

            {/* Stats */}
            <div className="lg:w-72 grid grid-cols-2 gap-4">
              {results?.map((stat, i) =>
              <div key={i} className="p-5" style={{ border: '1px solid #222', backgroundColor: '#111' }}>
                  <div className="font-bold mb-1" style={{ fontSize: '28px', color: '#1AEF0F', fontFamily: "'Titillium Web', sans-serif" }}>
                    {stat?.value}
                  </div>
                  <div style={{ fontSize: '12px', color: '#888', lineHeight: '1.4' }}>{isFr ? stat?.labelFr : stat?.labelEs}</div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
      {/* Project Image */}
      <section style={{ backgroundColor: '#111' }}>
        <div className="max-w-[1200px] mx-auto px-[35px]">
          <img
            src="https://img.rocket.new/generatedImages/rocket_gen_img_1a356ee60-1782331295390.png"
            alt="Ciberseguridad - protección de datos y sistemas implementada por Innobox"
            className="w-full"
            style={{ display: 'block', maxHeight: '480px', objectFit: 'cover' }} />
          
        </div>
      </section>
      {/* Project Overview */}
      <section style={{ paddingTop: '80px', paddingBottom: '80px', backgroundColor: '#fff' }}>
        <div className="max-w-[1200px] mx-auto px-[35px]">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
            <div>
              <h2 className="font-bold text-black mb-6" style={{ fontSize: 'clamp(24px, 2.5vw, 36px)', fontFamily: "'Titillium Web', sans-serif" }}>
                Descripción del Proyecto
              </h2>
              <p style={{ fontSize: '16px', color: '#505050', lineHeight: '1.8', marginBottom: '20px' }}>
                Proyecto de ciberseguridad integral para una organización del sector financiero con presencia en múltiples 
                regiones. El alcance abarcó desde la evaluación inicial de riesgos hasta la implementación de controles 
                técnicos y el desarrollo de un programa de concientización para los colaboradores.
              </p>
              <p style={{ fontSize: '16px', color: '#505050', lineHeight: '1.8' }}>
                El proyecto se ejecutó en fases, priorizando la protección de activos críticos y garantizando el 
                cumplimiento de normativas sectoriales aplicables durante todo el proceso.
              </p>
            </div>
            <div>
              <h2 className="font-bold text-black mb-6" style={{ fontSize: 'clamp(24px, 2.5vw, 36px)', fontFamily: "'Titillium Web', sans-serif" }}>
                Alcance y Tecnologías
              </h2>
              <div className="space-y-3">
                {['Fortinet NGFW / FortiGate', 'Microsoft Sentinel (SIEM)', 'CrowdStrike Endpoint Protection', 'Tenable Nessus (Vulnerability Scanning)', 'Azure Active Directory / MFA', 'ISO 27001 Framework']?.map((tech, i) =>
                <div key={i} className="flex items-center gap-3">
                    <span style={{ width: '8px', height: '8px', backgroundColor: '#1AEF0F', borderRadius: '50%', flexShrink: 0 }} />
                    <span style={{ fontSize: '15px', color: '#333' }}>{tech}</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Challenge / Solution */}
      <section style={{ paddingTop: '80px', paddingBottom: '80px', backgroundColor: '#f5f5f5' }}>
        <div className="max-w-[1200px] mx-auto px-[35px]">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
            <div className="p-10" style={{ backgroundColor: '#0a0a0a' }}>
              <div className="flex items-center gap-3 mb-6">
                <i className="fas fa-exclamation-triangle text-yellow-400 text-xl" />
                <h3 className="font-bold text-white" style={{ fontSize: '22px', fontFamily: "'Titillium Web', sans-serif" }}>
                  El Desafío
                </h3>
              </div>
              <p style={{ fontSize: '15px', color: '#aaa', lineHeight: '1.8', marginBottom: '16px' }}>
                La organización había sufrido dos incidentes de seguridad en el último año, incluyendo un intento de 
                ransomware que comprometió temporalmente sistemas de producción. La postura de seguridad era reactiva 
                y sin una estrategia coherente.
              </p>
              <p style={{ fontSize: '15px', color: '#aaa', lineHeight: '1.8' }}>
                Adicionalmente, el cumplimiento normativo era deficiente y los colaboradores no contaban con 
                formación en ciberseguridad, representando el principal vector de riesgo para la organización.
              </p>
            </div>
            <div className="p-10" style={{ backgroundColor: '#1AEF0F' }}>
              <div className="flex items-center gap-3 mb-6">
                <i className="fas fa-check-circle text-black text-xl" />
                <h3 className="font-bold text-black" style={{ fontSize: '22px', fontFamily: "'Titillium Web', sans-serif" }}>
                  La Solución
                </h3>
              </div>
              <p style={{ fontSize: '15px', color: '#0a0a0a', lineHeight: '1.8', marginBottom: '16px' }}>
                Implementamos una arquitectura de seguridad en capas con NGFW perimetral, EDR en endpoints, SIEM 
                para correlación de eventos y MFA obligatorio para todos los accesos críticos.
              </p>
              <p style={{ fontSize: '15px', color: '#0a0a0a', lineHeight: '1.8' }}>
                Desarrollamos un programa de concientización trimestral con simulaciones de phishing y capacitaciones 
                prácticas, logrando reducir la tasa de clics en correos maliciosos en un 78% en 6 meses.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Capabilities */}
      <section style={{ paddingTop: '80px', paddingBottom: '80px', backgroundColor: '#fff' }}>
        <div className="max-w-[1200px] mx-auto px-[35px]">
          <div className="mb-12">
            <h2 className="font-bold text-black mb-3" style={{ fontSize: 'clamp(24px, 2.5vw, 36px)', fontFamily: "'Titillium Web', sans-serif" }}>
              Capacidades Aplicadas
            </h2>
            <p style={{ fontSize: '16px', color: '#505050', maxWidth: '600px', lineHeight: '1.6' }}>
              Competencias técnicas y metodológicas que hicieron posible este proyecto de ciberseguridad.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-0">
            {capabilities?.map((cap, i) =>
            <div
              key={i}
              className="group p-8 transition-all duration-300 hover:bg-[#f9f9f9]"
              style={{ borderBottom: '1px solid #E2E2E2', borderRight: i % 3 !== 2 ? '1px solid #E2E2E2' : 'none' }}>
              
                <div className="mb-5 flex items-center justify-center" style={{ width: '52px', height: '52px', border: '1px solid #E2E2E2', borderRadius: '50%' }}>
                  <i className={`${cap?.icon} text-xl text-black group-hover:text-[#1AEF0F] transition-colors duration-300`} />
                </div>
                <h3 className="font-semibold text-black mb-3" style={{ fontSize: '17px', fontFamily: "'Titillium Web', sans-serif" }}>{cap?.title}</h3>
                <p style={{ fontSize: '14px', color: '#505050', lineHeight: '1.6' }}>{cap?.description}</p>
              </div>
            )}
          </div>
        </div>
      </section>
      {/* Sectors */}
      <section style={{ paddingTop: '60px', paddingBottom: '80px', backgroundColor: '#f5f5f5' }}>
        <div className="max-w-[1200px] mx-auto px-[35px]">
          <h2 className="font-bold text-black mb-10" style={{ fontSize: 'clamp(22px, 2vw, 30px)', fontFamily: "'Titillium Web', sans-serif" }}>
            Sectores que Atendemos
          </h2>
          <div className="flex flex-wrap gap-4">
            {sectors?.map((s, i) =>
            <div key={i} className="flex items-center gap-3 px-6 py-4 bg-white" style={{ border: '1px solid #E2E2E2' }}>
                <i className={`${s?.icon} text-[#1AEF0F]`} />
                <span style={{ fontSize: '15px', fontWeight: '600', color: '#111' }}>{s?.label}</span>
              </div>
            )}
          </div>
        </div>
      </section>
      {/* CTA */}
      <section style={{ paddingTop: '70px', paddingBottom: '70px', backgroundColor: '#1AEF0F' }}>
        <div className="max-w-[1200px] mx-auto px-[35px] flex flex-col sm:flex-row items-center justify-between gap-6">
          <p className="text-black font-bold m-0" style={{ fontSize: 'clamp(18px, 2vw, 26px)', fontFamily: "'Titillium Web', sans-serif", lineHeight: '1.3' }}>
            {isFr ? 'Vous voulez des résultats similaires pour votre organisation ?' : '¿Quieres resultados similares para tu organización?'}
          </p>
          <Link href="/contact" className="group relative inline-flex items-center overflow-hidden border border-black text-black bg-transparent flex-shrink-0" style={{ padding: '14px 32px', fontSize: '15px', fontWeight: 'bold', transition: 'all 300ms ease-out' }}>
            <span className="relative z-10 transition-colors duration-300 group-hover:text-white">{p?.ctaBtnContact}</span>
            <span className="absolute inset-0 bg-black transform translate-x-full group-hover:translate-x-0 transition-transform duration-300" style={{ zIndex: 0 }} />
          </Link>
        </div>
      </section>
      <Footer />
    </div>
  );

}